<template>
  <div class="ccs-layout">
    <div class="ccs-layout ccs-6 ccs-layout--no-pad">
      <ccs-input class="ccs-6" v-model.trim="fieldsValues.name" v-bind="fieldsDefinitions.name"
        @error="(err) => setFieldError('name', err)"/>
      <ccs-input class="ccs-6" v-model.trim="fieldsValues.fnd_id" v-bind="fieldsDefinitions.fnd_id"
        :items="fndsForSelect" @change="onFndSearch" @select="fillResponsibles" :required="!!fieldsValues.fnd_id"
        @error="(err) => setFieldError('fnd_id', err)"/>
      <ccs-input class="ccs-12" v-model.trim="fieldsValues.description"
        v-bind="fieldsDefinitions.description"
        @error="(err) => setFieldError('description', err)"/>
    </div>
    <div class="ccs-layout ccs-6 ccs-layout--no-pad">
      <ccs-input class="ccs-9" v-model="responsibleID" v-bind="fieldsDefinitions.responsible"
        :items="responsiblesForSelect" :disabled="!fieldsValues.fnd_id" :required="!!fieldsValues.fnd_id"
        @change="onResponsibleSearch" @error="(err) => setFieldError('responsible', err)"/>
      <div class="ccs-3 button--add">
        <button
          class="ccs-button ccs-button--small ccs-12"
          :disabled="!fieldsValues.fnd_id"
          @click="addResponsible">
          Добавить
        </button>
      </div>
      <div class="ccs-layout ccs-12 ccs-layout--scroll project-responsibles_list">
        <div class="ccs-tag ccs-tag--normal" v-for="(item, index) in responsibles" :key="index"
          @click="removeResponsible(item.id)">
          {{ `${item.full_name}` }}
        </div>
      </div>
    </div>
    <div class="ccs-layout ccs-layout--no-pad">
      <div>
        <button class="ccs-button" @click="submit">
          Создать проект
        </button>
      </div>
      <div>
        <button class="ccs-button ccs-button--light" @click="$emit('close')">
          Отмена
        </button>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapGetters, mapMutations } from 'vuex';

import { executeApiGetRequest } from '@/helpers/api-requests';

import FormHelper from '@/mixins/FormHelper.js';
import AutocompleteParent from '@/mixins/AutocompleteParent.js';

import Input from '@/components/forms/Input.vue';

export default {
  name: 'Project',
  mixins: [AutocompleteParent, FormHelper],
  components: {
    'ccs-input': Input,
  },
  data() {
    return {
      fieldsDefinitions: {
        name: {
          isValid: false,
          error: '',
          required: true,
          type: "text",
          label: "Название",
          placeholder: "Введите название",
        },
        fnd_id: {
          isValid: false,
          validationRules: {
            requiredFields: ['responsible'],
          },
          error: '',
          type: "autocomplete",
          label: "ФНД",
          placeholder: "Поиск по названию",
        },
        description: {
          isValid: false,
          error: '',
          required: false,
          type: "textarea",
          label: "Описание",
          placeholder: "Введите описание",
        },
        responsible: {
          isValid: false,
          validationRules: {
            requiredFields: ['fnd_id'],
          },
          error: '',
          type: "autocomplete",
          label: "Ответственные",
          placeholder: "Начните ввод для поиска",
        },
      },
      fieldsValues: {
        name: '',
        description: '',
        responsible: [],
        fnd_id: undefined,
      },
      fndsForSelect: [],
      fndsForSelectRawData: [],
      responsiblesForSelect: [],
      responsiblesForSelectRawData: [],
      responsibles: [],
      responsibleID: undefined,
    }
  },
  props: {
    data: {
      type: Object,
      default: () => {
        return undefined;
      },
    },
  },
  computed: {
    ...mapState('events', ['event']),
  },
  methods: {
    ...mapActions('projects', ['createProject']),
    addResponsible() {
      const responsible = this.responsiblesForSelectRawData.find(item => item.id === this.responsibleID);
      this.responsibles.push(responsible);
      this.responsibleID = undefined;
    },
    removeResponsible(responsibleID) {
      this.responsibles = this.responsibles.filter(item => item.id !== responsibleID);
    },
    async onResponsibleSearch(text) {
      [this.responsiblesForSelect, this.responsiblesForSelectRawData] = await this.getAutocompleteData(`/v1/events/${this.event.id}/employees/list`,
        `${text}&fnd_id=${this.fieldsValues.fnd_id}&role=block_leader`, 'id', 'email', (item) => `${item.full_name} <${item.email}>`);
    },
    async onFndSearch(text) {
      [this.fndsForSelect] = await this.getAutocompleteData('/v1/fnd/list', text, 'id', 'code');
    },
    async fillResponsibles(fndID) {
      if (!fndID) return;
      try {
        const requestData = await executeApiGetRequest(`/v1/events/${this.event.id}/employees/list`,
          {fnd_id: fndID, role: 'block_leader'});
        this.responsibles = [];
        requestData.data.forEach(item => {
          this.responsibles.push(item);
        });
      } catch (err) {
        this.$toasted.error(err.message);
      }
    },
    async submit() {
      this.fieldsValues.responsible = this.responsibles.reduce((result, item) => {
        result.push(item.id);
        return result;
      }, []);
      this.validateForm();
      if (this.isFormValid) {
        try {
          await this.createProject(this.fieldsValues);
          this.$toasted.success('Проект добавлен');
          this.$emit('close');
        } catch (err) {
          this.showServerValidationErrors(err);
        }
      }
    },
  },
}
</script>

<style lang="scss" scoped>
.button--add {
  margin-top: 22px;
}
</style>